import RestClient from '../../../../api/axiosInterceptor';
import { shareKeyActions } from '../../../actions/user/patient/generate_key';

/**
 * Creates an async action creator with standardized error handling and request flow
 *
 * @param {Object} actionType - Object with REQUEST, SUCCESS, and FAILURE properties
 * @param {Function} apiCall - Async function that performs the API request
 * @returns {Function} Thunk action creator function
 */
const createAsyncAction =
	(actionType, apiCall) => async (dispatch, getState) => {
	  try {
	    // Dispatch request action
	    dispatch({ type: actionType.REQUEST });

	    // Execute API call
	    const response = await apiCall();

	    // Dispatch success action with data
	    dispatch({
	      type: actionType.SUCCESS,
	      payload: response.data
	    });

	    return response;
	  } catch (error) {
	    // Extract error message with fallbacks
	    const errorMessage =
				error.response?.data?.error ||
				error.response?.data?.detail ||
				error.message ||
				'An unexpected error occurred';

	    // Dispatch failure action with error message
	    dispatch({
	      type: actionType.FAILURE,
	      payload: errorMessage
	    });

	    // Re-throw to allow component-level error handling
	    throw error;
	  }
	};

/**
 * Creates a new sharing key with the given permission level
 * @param {string} permissionType - Either 'view' or 'edit'
 * @returns {Function} Thunk action creator
 */
export const generateKey = (permissionType = 'view') =>
  createAsyncAction(shareKeyActions.GENERATE_KEY, () =>
    RestClient.post('/patient/generate-key/', { key_type: permissionType })
  );

/**
 * Create an action to set the sharing key
 * @param {Object} shareKey - The sharing key object to set
 * @returns {Object} Action object
 */
export const setShareKey = (shareKey) => ({
  type: shareKeyActions.SET_SHARE_KEY,
  payload: shareKey
});

/**
 * Create an action to clear the sharing key
 * @returns {Object} Action object
 */
export const clearShareKey = () => ({
  type: shareKeyActions.CLEAR_SHARE_KEY
});
